import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-waiting-payment-dialog-kit',
  imports: [MatProgressSpinnerModule, MatButtonModule, CommonModule],
  templateUrl: './waiting-payment-dialog-kit.component.html',
  styleUrl: './waiting-payment-dialog-kit.component.css'
})
export class WaitingPaymentDialogKitComponent {
  copied = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  copyPix() {
    if (this.data.pixCopyPaste) {
      navigator.clipboard.writeText(this.data.pixCopyPaste);
      this.copied = true;
      setTimeout(() => this.copied = false, 1600);
    }
  }
}
